export default {
  INDIRECT_SUBJECT_SEPARATOR: '___',
  isValidIndirectSubjectId: function isValidIndirectSubjectId(id) {
    return /^.+___.+$/.test(id);
  },
  PAYMENT_ID: 'PAYMENT',
  PAYMENT_DEFAULT_PRODUCT: 'PAYMENT',
  SHIPPING_ID: 'SHIPPING',
  SHIPPING_DEFAULT_PRODUCT: 'SHIPPING'
};